import { render, staticRenderFns } from "./TrInputV2.vue?vue&type=template&id=1e72b3d2&scoped=true&"
import script from "./TrInputV2.vue?vue&type=script&lang=js&"
export * from "./TrInputV2.vue?vue&type=script&lang=js&"
import style0 from "./TrInputV2.vue?vue&type=style&index=0&id=1e72b3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e72b3d2",
  null
  
)

export default component.exports